/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_Us_DescInputs */

const en_terms_section_2_term_us_desc = /** @type {(inputs: Terms_Section_2_Term_Us_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauris Linde, a self-employed sole trader registered with the Latvian State Revenue Service and trading under the name Lindevo. Lindevo is a trading name, not a registered company — see`)
};

const lv_terms_section_2_term_us_desc = /** @type {(inputs: Terms_Section_2_Term_Us_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauris Linde, Valsts ieņēmumu dienestā reģistrēts saimnieciskās darbības veicējs, kas darbojas ar nosaukumu Lindevo. Lindevo ir zīmolvārds, nevis reģistrēts uzņēmums — skatiet`)
};

/**
* | output |
* | --- |
* | "Nauris Linde, a self-employed sole trader registered with the Latvian State Revenue Service and trading under the name Lindevo. Lindevo is a trading name, no..." |
*
* @param {Terms_Section_2_Term_Us_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_us_desc = /** @type {((inputs?: Terms_Section_2_Term_Us_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_Us_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_us_desc(inputs)
	return en_terms_section_2_term_us_desc(inputs)
});